import { Command } from 'commands/Commands';

export class ChangeArticleTitle extends Command {
  type: string = 'BlogArticle.ChangeTitle';
  constructor(public id: string, newValue: string) {
    super(newValue, id);
  }
  priority: number = 100;
}
